import { cleanDoubleSlashes } from '@nx/populate-url'

export const getLiveAuctionUrl = ({
  rowid,
  isMobile = false,
  baseAMUrl,
}: {
  rowid: string
  isMobile?: boolean
  baseAMUrl: string
}) =>
  cleanDoubleSlashes(
    `${baseAMUrl}live-auction${isMobile ? '-mobile' : ''}/${rowid}`
  )

export type BuildAuctionRegistrationUrlProps = {
  rowId: string
  currentPath: string
  baseUrl: string
  baseAMUrl: string
}

export const buildAuctionRegistrationUrl = ({
  rowId,
  currentPath,
  baseUrl,
  baseAMUrl,
}: BuildAuctionRegistrationUrlProps) => {
  const finalPath = encodeURIComponent(baseUrl + currentPath)

  return cleanDoubleSlashes(
    `${baseAMUrl}register-to-bid/${rowId}?return_to_widget=${finalPath}`
  )
}
